import { createRouter, createWebHistory } from 'vue-router'
import EnbPainel from '../views/EnbPainel.vue'
import MyStore from '../views/MyStore.vue'
import Theme01 from './Theme01'
import Painel from './Painel'
import EnbAdm from '../views/EnbAdm'
import Adm from './Adm'
import EnbStart from '../views/EnbStart'
import FrenteLoja from '@/views/FrenteLoja'
import store from '../store'
import PwRecovery from '../components/PwRecovery/PwRecovery'
import RoutePwRecovery from './PwRecovery'

const routes = [
  {  
    path: '/painel',
    name: 'Painel',
    component: EnbPainel,
    children: Painel
  },
  {
    path: '/',
    name: 'Minha Loja',
    component: MyStore,
    children: Theme01
  },
  {
    path: '/loja',
    name: 'Minha Loja',
    component: MyStore,
    children: Theme01
  },
  {
    path: '/inicio',
    name: 'Get started',
    component: EnbStart
  },
  {
    path: '/',
    name: 'Frente de loja',
    component: FrenteLoja
  },
  {
    path: '/enb/login',
    name: 'Enb Adm',
    component: EnbAdm,
    children: Adm
  },
  {
    path: '/pwrecovery',
    name: 'Recuperação de senha',
    component: PwRecovery,
    children: RoutePwRecovery
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach( async (to) => {
  if(store.getters.PedidoAtual.length > 0 && store.getters.PedidoAtual[0].status === 'Recebido') {
    store.dispatch('ClearCheckout01')
      .then(() => store.dispatch('SetPedidoAtual', []))
  }
  if(to.path === '/product/' + to.params.id) {
    let product = await store.dispatch('GetProductView', parseInt(to.params.id))
    if(product === null) {
      return '/'
    }
  }
  if(to.name === 'Produto' || to.name === 'Categoria Produto') {
    await store.dispatch('GetProductId', to.params.link)
  }
  if(store.getters.Empresa.modelo === 'Modelo 03' && to.path.indexOf('/produtos') >= 0) {
    return to.path.replace('/produtos', '/captacoes')
  }
})

export default router
